import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectPurchaseDetails, selectPurchaseDetailsRequestStatus } from '@Header/Account/ducks/selectors';
import MenuLine from '../../Shared/MenuLine';

import PurchaseInProgressCard from '../../Shared/PurchaseInProgressCard';
import { HeaderTypography, PurchaseWrapper } from '../../Shared/Account/PurchaseWrapper.styles';

const Purchase = ({ isPurchaseRequestInProgress, purchaseDetails }) => {
  const {
    stockNumber,
    vehicleId,
    year,
    make,
    model,
    totalPrice,
    orderState
  } = purchaseDetails;

  const hasPurchaseDetails =
    stockNumber && vehicleId && year && make && model && totalPrice && orderState && orderState.toLowerCase() !== 'reserved';

  if (hasPurchaseDetails) {
    return (
      <Fragment>
        {isPurchaseRequestInProgress ? null : (
          <>
            <PurchaseWrapper>
              <HeaderTypography>Purchase In Progress</HeaderTypography>
              <PurchaseInProgressCard purchaseDetails={purchaseDetails} />
            </PurchaseWrapper>
            <MenuLine />
          </>
        )}
      </Fragment>
    );
  }
  return null;
};

Purchase.propTypes = {
  purchaseDetails: PropTypes.shape({}).isRequired,
  isPurchaseRequestInProgress: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  purchaseDetails: selectPurchaseDetails(state).purchaseDetails,
  purchaseDetailsRequestStatus: selectPurchaseDetailsRequestStatus(state)
});

export default connect(mapStateToProps)(Purchase);
